<div class="container">
  <section class="section-top">
    <div class="column-icon">
      <div class="section-icon-networks">

        <figure class=figure-logo>
          <img class=icon-logo src="../../../../assets/img/versiones_logo5.png" alt="Logo Fruzty"/>
        </figure>
        <p class="slogan">
          {{'HomeFooter.Slogan' | translate}}
        </p>

        <section class="section-social-networks">
          <a (click)="openLink(linkedInUrl)" class="icon-click" >
            <figure class=figure-circle>
              <i class="pi pi-linkedin icon-network"></i>
            </figure>
          </a>
          <a (click)="openLink(instagramUrl)" class="icon-click">
            <figure class=figure-circle>
              <i class="pi pi-instagram icon-network"></i>
            </figure>
          </a>

          <!--
            <figure class=figure-circle>
              <i class="pi pi-facebook icon-network"></i>
            </figure>
            <figure class=figure-circle>
              <i class="pi pi-youtube icon-network"></i>
            </figure>
          -->
        </section>
      </div>


    </div>
    <section class="section-menu">

      <div class="column-menu">
        <h2 class="title-menu">{{'HomeFooter.Menu1.Title' | translate}}</h2>
        <a [href]="homeUrl" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu1.Item1' | translate}}</p>
        </a>
        <!-- <a (click)="visibleRequestCode()" class="icon-click" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu1.Item2' | translate}}</p>
        </a> -->
        <!-- <a [href]="loginUrl" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu1.Item3' | translate}}</p>
        </a> -->
      </div>
      <div class="column-menu">
        <h2 class="title-menu">{{'HomeFooter.Menu2.Title' | translate}}</h2>
        <a [href]="offersUrl" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu2.Item1' | translate}}</p>
        </a>
        <!--
          <a [href]="importRequestUrl" style="text-decoration: inherit; color:inherit">
            <p class="text-menu">{{'HomeFooter.Menu2.Item2' | translate}}</p>
          </a>
        -->
      </div>
      <div class="column-menu">
        <h2 class="title-menu">{{'HomeFooter.Menu3.Title' | translate}}</h2>
        <div>
          <a [href]="mailToUrl" style="text-decoration: inherit; color:inherit">
            <p class="text-menu">{{'HomeFooter.Menu3.Item1' | translate}}<br>{{contactEmail}}</p>
          </a>
        </div>

        <p class="text-menu">
          {{'HomeFooter.Menu3.Item2' | translate}}
          <br>
          {{'HomeFooter.Menu3.Item3' | translate}}
          <br>
          <span class="only-desktop">
            {{'HomeFooter.Menu3.Item4' | translate}}
            {{'HomeFooter.Menu3.Item5' | translate}}
          </span>
          <span class="only-mobile">
            {{'HomeFooter.Menu3.Item4' | translate}}
            <br>
            {{'HomeFooter.Menu3.Item5' | translate}}
          </span>
        </p>
      </div>

      <div class="column-menu only-mobile">
        <h2 class="title-menu hidden-item">{{'HomeFooter.Menu4.Title' | translate}}</h2>
        <a href="#" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu4.Item1' | translate}}</p>
        </a>
        <a href="#" style="text-decoration: inherit; color:inherit">
          <p class="text-menu">{{'HomeFooter.Menu4.Item2' | translate}}</p>
        </a>
      </div>

    </section>
  </section>
  <div class="container-divider">
    <div class="divider"></div>
  </div>
  <section class="section-bottom">
    {{'HomeFooter.CopyRight' | translate}}
    <div class="container-terms only-desktop">
      <a href="#" style="text-decoration: inherit; color:inherit">
        <p class="text-menu">{{'HomeFooter.Menu4.Item1' | translate}}</p>
      </a>
      |
      <a href="#" style="text-decoration: inherit; color:inherit">
        <p class="text-menu">{{'HomeFooter.Menu4.Item2' | translate}}</p>
      </a>
    </div>
  </section>
</div>


<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDialog" [style]="{width: '50wv'}">
  <app-requests-code></app-requests-code>
</p-dialog>

